import React, { useEffect, useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import {
  getDecryptedItem,
  setEncryptedItem,
} from "../../../utils/localStorageHelper";

const redirectUrl = process.env.REACT_APP_URL + "/account/dashboard";
const COUNTDOWN_DURATION = 5;
const COUNTDOWN_KEY = "paymentCountdownStart";

const PaymentConfirmation = () => {
  const [countdown, setCountdown] = useState(COUNTDOWN_DURATION);

  useEffect(() => {
    const countdownDurationMs = COUNTDOWN_DURATION * 1000;
    const currentTimestamp = Date.now();

    let storedStartTimestamp = getDecryptedItem(COUNTDOWN_KEY);

    if (!storedStartTimestamp) {
      storedStartTimestamp = currentTimestamp;
      setEncryptedItem(COUNTDOWN_KEY, storedStartTimestamp);
    }

    const countdownEndTimestamp = storedStartTimestamp + countdownDurationMs;

    let animationFrameId;

    const updateCountdown = () => {
      const now = Date.now();
      const secondsLeft = Math.max(
        Math.ceil((countdownEndTimestamp - now) / 1000),
        0
      );
      setCountdown(secondsLeft);

      if (secondsLeft <= 0) {
        handleRedirectNow();
        return;
      }

      animationFrameId = requestAnimationFrame(updateCountdown);
    };

    updateCountdown();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const handleRedirectNow = () => {
    localStorage.removeItem(COUNTDOWN_KEY);
    window.location.href = redirectUrl;
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
      sx={{
        background: "linear-gradient(to bottom right, #f0fdf4, #ebf8ff)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 450,
          width: "100%",
          borderRadius: 4,
          p: 4,
          textAlign: "center",
        }}
      >
        <Box mb={4}>
          <Box
            mx="auto"
            mb={2}
            width={64}
            height={64}
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            sx={{ backgroundColor: "#d1fae5" }}
          >
            <CheckCircleIcon sx={{ fontSize: 32, color: "#16a34a" }} />
          </Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Payment Successful!
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Thank you for your purchase. Your payment has been processed
            successfully.
          </Typography>
        </Box>

        <Box
          mb={4}
          p={2}
          borderRadius={2}
          bgcolor="grey.100"
          textAlign="center"
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={1}
          >
            <AccessTimeIcon
              fontSize="small"
              sx={{ color: "grey.600", mr: 1 }}
            />
            <Typography variant="body2" color="text.secondary">
              Redirecting automatically in
            </Typography>
          </Box>
          <Typography variant="h4" fontWeight="bold" color="primary">
            {countdown}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            seconds
          </Typography>
        </Box>

        <Box mb={2}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleRedirectNow}
            sx={{ py: 1.25, fontWeight: 600 }}
          >
            Go to Website Now
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary">
          If you're not redirected automatically,&nbsp;
          <Button onClick={handleRedirectNow} variant="text" size="small">
            <Typography
              variant="caption"
              color="primary"
              sx={{ textDecoration: "underline" }}
            >
              click here
            </Typography>
          </Button>
        </Typography>

        <Divider sx={{ my: 2 }} />
      </Paper>
    </Box>
  );
};

export default PaymentConfirmation;
